<template>
  <div class="GuaranteeList">
    <div
      @mouseover="checkout(index)"
      @mouseleave="checkouts(index)"
      v-for="(item, index) in GuarAnteeList"
      :key="index"
      :style="{ 'background-color': (item.status == '0' ? item.color : '') }"
      class="Guarantee_box"
    >
      <div v-if="item.status == '0'" class="Guarantee_name">{{ item.name }}</div>
      <div style="    width: 100%;" v-if="item.status == '1'"> 
        <div class="hear_name">
          <div class="shuxian" :style="{ backgroundColor: item.color }"></div>
          <div class="guarantees_name">{{ item.name }}</div>
        </div>
        <div class="content">{{ item.content }}</div>
        <div class="btns">
          <el-button
            style="width:97%;height:36px;color: #3FAFFE;border:#3FAFFE"
            @click="goBidSecurity(item.baoid,item.name)"
          >立即申请</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  name: "Guarantee",
  data() {
    return {
      GuarAnteeList: [
        {
          name: "投标保函",
          color: "#41A4FF",
          content:
            "在招标投标中招标人为保证投标人不得撤销投标文件、中标后不得无正当理由不与招标人订立合同等，促进交易的顺利执行",
          status: "0",
          baoid: 4
        },
        {
          name: "履约保函",
          content:
            "应劳务方和承包方(申请人)的请求，担保机构向工程的业主方(招标人）做出的一种履约保证承诺。",
          color: "#17E3D1",
          status: "0",
          baoid: 2
        },
        {
          name: "业主支付保函",
          color: "#6384FF",
          content:
            "客户申请向工程承包项目中的业主或商品买卖中的买方出具的，保证申请人严格履行承包合同或供货合同的书面文件",
          status: "0",
          baoid: 1
        },
        {
          name: "农民工工资支付保函",
          color: "#0054FE",
          content:
            "客户申请向工程承包项目中的业主或商品买卖中的买方出具的，保证申请人严格履行承包合同或供货合同的书面文件",
          status: "0",
          baoid: 3
        },
        {
          name: "质量保函",
          color: "#FFBE4E",
          content:
            "应供货方或承建人申请，向买方或业主保证，工程不符合约定而承建人又不能依约更换或修理时，按买方的索赔予以赔偿的书面文件",
          status: "0",
          baoid: 5
        },
        {
          name: "预付款保函",
          color: "#0A84F5 ",
          content:
            "承包人委托担保机构向业主出具的由业主按合同规定向承包人支付一笔工程预付款，及时用于实施项目的保证函件。",
          status: "0",
          baoid: 7
        }
      ]
    };
  },
  methods: {
    checkout(index) {
      this.GuarAnteeList[index].status = "1";
    },
    checkouts(index) {
      this.GuarAnteeList[index].status = "0";
    },
    goBidSecurity(index, name) {
      console.log("huoqu", index);
      sessionStorage.setItem("bhleix", index); //当前所选保函类型id
      sessionStorage.setItem("bhlein", name); //当前所选保函类型名称
      if(name=="预付款保函"){
          this.$message('当前保函暂未开通服务');
          return
      }
      console.log(
        "chaxun",
        sessionStorage.getItem("bhleix"),
        sessionStorage.getItem("bhlein")
      );
      this.$router.push({ name: "BidSecurity" });
    }
  }
};
</script>
<style scoped>
.btns {
  padding-left: 40%;
  /* position: relative;
  left: 57%; */
}

.Guarantees_box {
  width: 331px;
  height: 150px;
  margin-right: 10px;
}

.guarantees_name {
  font-size: 20px;
  color: #333;
  margin-left: 10px;
  font-weight: Bold;
}

.content {
  width: 100%;
     overflow: hidden;
    /*将对象作为弹性伸缩盒子模型显示*/
    display: -webkit-box;
    /*设置子元素排列方式*/
    -webkit-box-orient: vertical;
    /*设置显示的行数，多出的部分会显示为...*/
    -webkit-line-clamp: 3;
  height: 60px;
  font-size: 14px;
  color: #333;
  margin-left: 4px;
}

.hear_name {
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
}

.shuxian {
  width: 7px;
  height: 28px;
  background-color: #41a4ff;
  margin-left: 4px;
}

.Guarantee_name {
  color: #ffffff;
  font-size: 22px;
}

.Guarantee_box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 47%;
  height: 150px;
  margin-right: 10px;
  /* background-color: #41A4FF; */
}

.GuaranteeList {
  width: 50%;
  height: 475px;
  margin-left: 10px;
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
  /* margin-left: 20px; */
  align-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/view/index/Guarantee.vue